<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
  computed: {
    start() {
      const day = this.module.startDay.toString();
      const time = this.module.startTime.toString();
      return `${day ? `${day}д.` : ''}${time && day ? ' ' : ''}${time}` || '-';
    },
    duration() {
      const day = this.module.durationDay.toString();
      const time = this.module.durationHour.toString();
      return `${day ? `${day} д.` : ''}${time && day ? ' ' : ''}${time}` || '-';
    },
  },
};
</script>
<template>
  <FBody
    type="line"
    :module="module"
    @submit="$emit('submit')"
  >
    <FStatic
      label="Начало"
      width="100px"
      shrink="0"
    >
      {{start}}
    </FStatic>
    <FStatic
      label="Продол."
      width="100px"
      shrink="0"
    >
      {{duration}}
    </FStatic>
    <FStatic
      :label="module.service.toString()"
    >
      {{module.name}}
    </FStatic>
    <FBtn
      icon="el-icon-edit"
      width="24px"
      shrink="0"
      title="Удалить"
      @click="$emit('edit', module)"
    />
    <FBtn
      icon="el-icon-delete"
      width="24px"
      shrink="0"
      title="Удалить"
      @click="$emit('remove', module)"
    />
  </FBody>
</template>
<style lang="scss">

</style>
